<template>
  <div style="padding: 20px">
    <el-button type="primary" @click="addUser">添加业主</el-button>
    <pagination-table
      ref="table"
      :data="ownerList"
      :columns="columns"
      :actions="actions"
      :loader="getOwnerList"
      :async="true"
      :pageSizes="[20]"
      :style="{ width: '70%' }"
    ></pagination-table>
    <el-dialog
      v-drag:common
      :visible="visible"
      :title="title"
      width="500px"
      @close="visible = false"
    >
      <el-form>
        <el-form-item label="业主名称" prop="ownerName">
          <el-input
            v-model="ownerName"
            placeholder="请输入业主名称"
            style="width: 300px"
            :maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item label="业主全称" prop="fullName">
          <el-input
            v-model="fullName"
            placeholder="请输入业主全称"
            style="width: 300px"
            :maxlength="50"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="saveOwner">保存</el-button>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: '',
      ownerList: [],
      visible: false,
      ownerName: '',
      fullName: '',
      ownerId: '',
      columns: [
        {
          prop: 'name',
          label: '业主'
        },
        {
          prop: 'fullName',
          label: '全称'
        }
      ],
      actions: [
        {
          label: '编辑',
          type: 'primary',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.editUser(row);
            this.title = '编辑业主';
          }
        },
        {
          label: '删除',
          type: 'danger',
          plain: true,
          style: 'btn',
          onClick: (index, row) => {
            this.delUser(row);
          }
        }
      ]
    };
  },
  async mounted() {
    await this.getOwnerList({ page: 0 });
  },
  methods: {
    async getOwnerList(options) {
      const { data } = await this.$fetch('/manage/station/getOwnerList', {
        module: 'manage',
        params: { pageNo: options.page }
      });
      this.ownerList = data.defaultParam && data.defaultParam.rows;
      return {
        data: data.defaultParam && data.defaultParam.rows,
        total: data.defaultParam && data.defaultParam.total
      };
    },
    addUser() {
      this.title = '新增业主';
      this.editUser();
    },
    async delUser(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(async () => {
          await this.$postForm({
            url: '/manage/station/delUser',
            module: 'manage',
            data: { ownerId: row.ownerId },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          this.$refs.table.load();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    async editUser(row) {
      this.visible = true;
      this.ownerName = row && row.name;
      this.fullName = row && row.fullName;
      this.ownerId = (row && row.ownerId) || '0';
    },
    async saveOwner() {
      await this.$fetch({
        url: '/manage/station/saveOwner',
        module: 'manage',
        method: 'post',
        data: {
          owner: {
            name: this.ownerName,
            fullName: this.fullName,
            ownerId: this.ownerId
          }
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      this.$refs.table.load();
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}
</style>
